// Shared neutral base — the constant across both disciplines.
const base = {
  bg: '#080808',
  bgAlt: '#0d0d0d',
  surface: '#111111',
  surfaceAlt: '#161616',
  surfaceElevated: '#1c1c1c',
  border: 'rgba(255,255,255,0.07)',
  borderHover: 'rgba(255,255,255,0.15)',
  white: '#FFFFFF',
  textPrimary: '#F0F0F0',
  textSecondary: '#888888',
  textMuted: '#505050',
};

// Coaching identity — performance blue.
export const colors = {
  ...base,
  accent: '#3B82F6',
  accentLight: '#60A5FA',
  accentDim: 'rgba(59,130,246,0.12)',
  accentGlow: 'rgba(59,130,246,0.25)',
};

// Web/IT identity — technical violet. Same neutrals, different signal.
export const webColors = {
  ...base,
  accent: '#8B7CF6',
  accentLight: '#A99BFF',
  accentDim: 'rgba(139,124,246,0.12)',
  accentGlow: 'rgba(139,124,246,0.25)',
};

export const fonts = {
  display: "'Oswald', 'Arial Black', Impact, sans-serif",
  body: "'Space Grotesk', Arial, sans-serif",
  mono: "ui-monospace, SFMono-Regular, 'JetBrains Mono', Menlo, Consolas, monospace",
};

export const bp = {
  mobile: '480px',
  tablet: '768px',
  desktop: '1024px',
  wide: '1280px',
};

